<template>
  <div>
    <h1 class="unicorn-h1 mt-4">Мониторинг</h1>
    <h4 class="unicorn-h4 mb-8">Выбор класса</h4>

    <core-loading v-if="loading && !dataset.length" />

    <div v-else-if="error && !dataset.length">
      <u-alert variant="danger" icon="mdi-alert">
        <template #title>
          Ошибка!
        </template>

        <p>{{ errorText }}</p>

        <u-button class="mt-4" variant="secondary" text @click="reload">
          Повторить
        </u-button>
      </u-alert>
    </div>

    <div v-else v-for="(classes, key) in dataset" :key="key" class="mb-8">
      <h4 class="mb-4 unicorn-h4">{{ key }}-е классы</h4>
      <u-divider />

      <div class="-mx-2 -mt-2">
        <u-button
          @click="
            $router.push({
              name: 'class-monitoring',
              params: { classId: cl.id },
              query: { liter: cl.liter, number: cl.number }
            })
          "
          class="mx-2 my-2"
          v-for="cl in classes"
          :key="cl.id"
        >
          {{ cl.number }} {{ cl.liter }}
        </u-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import apiService from "../services/Api";
import { groupBy } from "lodash";

export default {
  name: "Monitoring",

  data() {
    return {
      dataset: [],
      loading: true,
      error: null
    };
  },

  watch: {
    async reloadToken() {
      await this.load();
    }
  },

  computed: {
    ...mapState("connection", ["reloadToken"]),

    errorText() {
      const { kind } = apiService.describeError(this.error);

      if (kind === "session") return "Сессия недействительна, войдите заново.";

      return "Нет связи со школьным сервером. Список классов появится, как только связь восстановится.";
    }
  },

  async mounted() {
    await this.load();
  },

  methods: {
    reload() {
      this.$store.dispatch("connection/bumpReload");
    },

    async load() {
      this.loading = true;
      this.error = null;

      try {
        const response = await apiService.monitoring.getClasses();
        this.dataset = groupBy(response.data, "number");
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
